import React from 'react';
import Page from './../../components/Page';

const Settings = props => {
  return (<Page title="Настройки">
    Настройки
  </Page>)
}

export default Settings;